export const ConnectionNavbar = {
  flow: 'x',
  align: 'center space-between',
  padding: '0',
  round: 'radiusPill',
  gap: 'A',
  theme: 'canvas-card-glass',
  ':hover .avatar': {
    opacity: 0
  },
  ConnectionLabel: {
    gap: 'Y1',
    margin: '- - - A+V',
    lineHeight: 1,
    onClick: (ev, el) => {
      el.call('openInNewTab')
    },
    ':hover': {
      textDecoration: 'underline'
    },
    Circle: {
      boxSize: 'Y1',
      isActive: true,
      position: 'relative',
      isLoading: false,
      animationIterationCount: 'infinite',
      '.isLoading': {
        animation: 'blinking',
        animationDuration: 'G2'
      },
      '!isLoading': {
        animation: null
      },
      onRender: (el, s) => {
        // The checkpoint bus is an ENHANCEMENT, not a precondition. A host
        // that boots without an SDK (UI-kit catalog, preview frame, spec
        // host) still names the connection and still paints the dot; only
        // the auto-save blink is missing. Same guard shape as
        // packages/workspace/analyzing.js's own rootBus subscriptions.
        if (!el.sdk?.rootBus?.on) return
        const handler = ({ origin }) => {
          if (origin === 'auto') {
            el.update({
              isLoading: true
            })
            setTimeout(
              () =>
                el.update({
                  isLoading: false
                }),
              1000
            )
          }
        }
        el.sdk.rootBus.on('checkpoint:done', handler)
      }
    },
    Text: {
      maxWidth: '100%',
      text: (el) => el.getAppKey(),
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      padding: '- - .1em'
    },
    CopyButton: null
  },
  NavbarButtonSet: {
    padding: '0 X',
    gap: 'Y',
    VersionsButton: {
      hide: (el) => !el.hasProjectPermission('editMode'),
      icon: 'version outline',
      title: (el) => el.call('polyglot', 'editor.connection.publishingVersions'),
      scrollToTop: false,
      onClick: (ev, el) => {
        el.getRootState().toggle('isVersionsOpen', {
          preventUpdate: true
        })
        el.getVersionsAside()?.update()
      }
    },
    Pub: {
      hide: (el) => !el.hasProjectPermission('editMode'),
      icon: 'upload outline',
      title: (el) => el.call('polyglot', 'editor.connection.publishingVersions'),
      scrollToTop: false,
      onClick: async (ev, el) => {
        await el.call('openRouterModal', '/publish')
      }
    },
    SettingsButton: {
      extends: 'Link',
      title: (el) => el.call('polyglot', 'editor.zoombar.settings'),
      color: 'paragraph',
      icon: 'settings outline',
      isActive: (el) => el.getWindow('modal') === 'Settings',
      scrollToTop: false,
      onClick: async (ev, el) => {
        await el.call('openRouterModal', '/settings', {
          key: '/settings'
        })
      }
    },
    childProps: {
      padding: 'Y1'
    }
  }
}
